import { Link } from 'react-router-dom';

/**
 * Homepage curriculum tile slider. Mirrors `.curriculum-slider .curriculum-track`
 * from design-source/index.html lines 1284-1353.
 *
 * Each tile has a hover-reveal `.lower` paragraph (collapsed copy that opens
 * on hover). Items default to the design's 5 stages but can be overridden
 * with `items` prop pulled from /api/level-cards.
 */
const isInternal = (u) => u && u.startsWith('/');

const FALLBACK = [
  { id: 'l1', image: 'https://images.unsplash.com/photo-1587560699334-cc4ff634909a?w=900&q=80', subheading: 'Ages 3–6',     title: 'Early Years',           description: 'Maple Leaf Early Years is the start of an exciting and rewarding lifelong journey. Young children are given new opportunities to explore, discover and grow together — developing their unique capabilities and a love of learning.', link: '/page/pg-kg' },
  { id: 'l2', image: 'https://images.unsplash.com/photo-1503676260728-1c00da094a0b?w=900&q=80', subheading: 'Class I – V',  title: 'Junior School',         description: 'Junior School builds on the formative work of Early Years, further shaping attitudes to learning through our structured teaching approach — helping students understand, master and apply core skills.', link: '/page/i-v' },
  { id: 'l3', image: 'https://images.unsplash.com/photo-1427504494785-3a9ca7044f45?w=900&q=80', subheading: 'Class VI – IX', title: 'Middle School',         description: 'Middle School supports the changing needs of students in their formative years, helping them transition from primary to secondary school as they continue to develop knowledge and skills.', link: '/page/vi-ix' },
  { id: 'l4', image: 'https://images.unsplash.com/photo-1456513080510-7bf3a84b82f8?w=900&q=80', subheading: 'Ages 14–16',    title: 'Senior School (IGCSE)', description: 'Senior School provides the ideal backdrop as students begin their pre-university years. Driven by IGCSE, students undertake rigorous academic study aligned with their strengths and ambitions.', link: '/page/igcse' },
  { id: 'l5', image: 'https://images.unsplash.com/photo-1571260899304-425eee4c7efc?w=900&q=80', subheading: 'Ages 16–18',    title: 'Senior School (IAL)',   description: "The International Advanced Level programme prepares students for the world's leading universities — supported by in-house career counselling and a 98% placement track record.", link: '/page/ial' },
];

export function CurriculumSlider({ items }) {
  // Map LevelCard rows from /api/level-cards onto the design shape if provided;
  // otherwise use the fallback 5 stages from the prototype.
  const list = (items && items.length)
    ? items.map((it) => ({
        id: it.id,
        image: it.image,
        subheading: it.ageRange,
        title: it.title,
        description: it.description,
        link: it.link,
      }))
    : FALLBACK;

  return (
    <section className="curriculum">
      <div className="container">
        <div className="curriculum-head reveal">
          <div className="section-eyebrow">Learning</div>
          <h2 className="section-title">Our <em>Curriculum</em></h2>
          <p className="section-lede">
            The Maple Leaf programme is tailored to suit each educational stage, building resilient and independent learners with a strong work ethic and critical skills in decision-making, leadership and inquiry. Students leave Maple Leaf as well-rounded young adults — with a love of learning and the drive to be active, contributing members of society.
          </p>
        </div>
      </div>
      <div className="inner-wrapper">
        <div className="curriculum-slider">
          <div className="curriculum-track">
            {list.map((it) => {
              const inner = (
                <>
                  <div className="img-outer">
                    <div className="img-c">
                      <div className="curriculum-tile" style={{ backgroundImage: `url('${it.image}')` }} />
                    </div>
                  </div>
                  <div className="text-c">
                    {it.subheading && <div className="subheading">{it.subheading}</div>}
                    <h3>{it.title}</h3>
                    <div className="lower">
                      {it.description && <p>{it.description}</p>}
                      <p className="link">Discover More</p>
                    </div>
                  </div>
                </>
              );
              const href = it.link || '#';
              return (
                <div className="tile-c" key={it.id}>
                  {isInternal(href)
                    ? <Link to={href}>{inner}</Link>
                    : <a href={href}>{inner}</a>}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
